var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-choose-plan-step"},[_c('plan-selector',{attrs:{"loading":_vm.loading,"selectedPlan":_vm.selectedPlan,"plans":_vm.plans},on:{"planChosen":_vm.planChosen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }